// @ts-nocheck
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext.jsx';
import { getCatalogReadiness, isPublishable } from '../content/repository.js';

const SITE_NAME = 'ANLEXX';

function setMeta(name, content, attribute = 'name') {
  let element = document.head.querySelector(`meta[${attribute}="${name}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, name);
    document.head.append(element);
  }
  element.setAttribute('content', content);
}

export function Seo({ title, description, noindex = false, schema = null }) {
  const location = useLocation();
  const { locale } = useI18n();
  useEffect(() => {
    document.title = `${title} — ${SITE_NAME}`;
    setMeta('description', description);
    setMeta('robots', noindex ? 'noindex,nofollow' : 'index,follow');
    setMeta('og:title', `${title} — ${SITE_NAME}`, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:type', 'website', 'property');
    setMeta('og:image', 'https://anlexx.uz/og.png', 'property');
    setMeta('og:image:width', '1536', 'property');
    setMeta('og:image:height', '1024', 'property');
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', `${title} — ${SITE_NAME}`);
    setMeta('twitter:description', description);
    setMeta('twitter:image', 'https://anlexx.uz/og.png');
    const canonicalUrl = `https://anlexx.uz${location.pathname}`;
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.setAttribute('rel', 'canonical'); document.head.append(canonical); }
    canonical.setAttribute('href', canonicalUrl);
    document.head.querySelectorAll('link[data-anlexx-hreflang]').forEach(node => node.remove());
    ['ru', 'uz', 'en'].forEach(lang => {
      const link = document.createElement('link');
      link.rel = 'alternate'; link.hreflang = lang; link.href = canonicalUrl; link.dataset.anlexxHreflang = 'true';
      document.head.append(link);
    });
    let script = document.head.querySelector('script[data-anlexx-schema]');
    if (schema) {
      if (!script) { script = document.createElement('script'); script.setAttribute('type', 'application/ld+json'); script.dataset.anlexxSchema = 'true'; document.head.append(script); }
      script.textContent = JSON.stringify(schema);
    } else script?.remove();
  }, [title, description, noindex, location.pathname, locale, schema]);
  return null;
}

export const schemaBuilders = {
  organization: () => ({ '@context': 'https://schema.org', '@type': 'Organization', name: 'ANLEXX', url: 'https://anlexx.uz', foundingDate: '2018-06-22', areaServed: 'UZ' }),
  breadcrumbs: items => ({ '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: items.map((item, index) => ({ '@type': 'ListItem', position: index + 1, name: item.name, item: `https://anlexx.uz${item.path}` })) }),
  software: name => ({ '@context': 'https://schema.org', '@type': 'SoftwareApplication', name, applicationCategory: 'BusinessApplication' }),
  product: (model, manufacturer) => {
    if (!model || !manufacturer || !getCatalogReadiness(model).ready) return null;
    return { '@context': 'https://schema.org', '@type': 'Product', name: model.title.ru, brand: { '@type': 'Brand', name: manufacturer.title.ru }, sku: model.slug };
  },
  offer: price => {
    if (!price?.confirmed || typeof price.value !== 'number' || !price.currency) return null;
    return { '@context': 'https://schema.org', '@type': 'Offer', price: price.value, priceCurrency: price.currency };
  },
  knowledge: material => {
    if (!material || !isPublishable(material) || material.evidenceIds.length === 0 || !['Article', 'TechArticle'].includes(material.schemaType)) return null;
    return { '@context': 'https://schema.org', '@type': material.schemaType, headline: material.title.ru, description: material.summary.ru, ...(material.publishedAt ? { datePublished: material.publishedAt } : {}) };
  },
};
